import angular from 'angular';
import component from './quicksight-embed.component';

const QuicksightEmbed = angular
    .module('control-room.events.components.quicksight-embed', [])
    .component('crQuicksightEmbed', component);

export default QuicksightEmbed;
